import { Bug, Flame, NodesRight, Star } from "@gravity-ui/icons";
import { IconData } from "@gravity-ui/uikit";
import { StatusResponseOverallEnum } from "definitions/poizon-bff";

import css from "./ServiceStatusNavigationItem.module.scss";

export const statusModifier: Record<StatusResponseOverallEnum, string> = {
  [StatusResponseOverallEnum.Operational]: css.statusOperational,
  [StatusResponseOverallEnum.Degraded]: css.statusDegraded,
  [StatusResponseOverallEnum.Down]: css.statusDown,
  [StatusResponseOverallEnum.Unknown]: css.statusUnknown,
};

export const statusIcon: Record<StatusResponseOverallEnum, IconData> = {
  [StatusResponseOverallEnum.Operational]: Star,
  [StatusResponseOverallEnum.Degraded]: Bug,
  [StatusResponseOverallEnum.Down]: Flame,
  [StatusResponseOverallEnum.Unknown]: NodesRight,
};
